/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * Who has to acknowledge this. A "specific room or team" option is not available: staff are not linked to rooms in the data model.
 */
export enum PublishAcknowledgementItemDtoScopeType {
  ALL_STAFF = "ALL_STAFF",
  ROLE = "ROLE",
  NAMED_INDIVIDUALS = "NAMED_INDIVIDUALS",
}
